<template>
    <div class="py-4 container-fluid">
        <div class="row">
            <div class="col-lg-12">
                <error v-if="error" :error="error" />
                <div class="row mt-4">
                    <div class="multisteps-form mb-9">
                        <div class="col-12 col-lg-8 m-auto">
                            <div class="card">
                                <div class="card-header p-0 position-relative mt-n4 mx-3 z-index-2">
                                    <div class="bg-gradient-success shadow-success border-radius-lg pt-4 pb-3">
                                        <div class="multisteps-form__progress">
                                            <h5 class="font-weight-bolder mb-0 mt-0 ms-4 text-white">Create Register</h5>
                                        </div>
                                    </div>
                                </div>
                                <div class="card-body">
                                    <form class="multisteps-form__form" @submit.prevent="submitForm">
                                        <div class="multisteps-form__panel border-radius-xl bg-white js-active position-relative">    
                                            <div class="multisteps-form__content">
                                                <div class="row mt-3">
                                                    <div class="col-6">
                                                        <div class="input-group input-group-static null">
                                                            <label>Email</label>
                                                            <input v-model="formData.email" type="text" class="form-control form-control-default" placeholder="Email">
                                                            <span v-if="v$.email.$error" class="text-sm text-danger">
                                                                {{ v$.email.$errors[0].$message }}
                                                            </span>
                                                        </div>           
                                                    </div>                    
                                                </div>
                                                <div class="row mt-4">
                                                    <div class="col-6">
                                                        <div class="input-group input-group-static null">
                                                            <label>Display name</label>
                                                            <input v-model="formData.displayName" type="text" class="form-control form-control-default" placeholder="Display name">
                                                            <span v-if="v$.displayName.$error" class="text-sm text-danger">
                                                                {{ v$.displayName.$errors[0].$message }}
                                                            </span>
                                                        </div>       
                                                    </div>          
                                                    <div class="col-6">
                                                        <div class="input-group input-group-static null">
                                                            <label>Animal species</label>
                                                            <input v-model="formData.animalSpecies" type="text" class="form-control form-control-default" placeholder="Animal species">
                                                            <span v-if="v$.animalSpecies.$error" class="text-sm text-danger">
                                                                {{ v$.animalSpecies.$errors[0].$message }}
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="row mt-4">
                                                    <div class="col-6">
                                                        <div class="input-group input-group-static null">
                                                            <label>Telephone number</label>
                                                            <input v-model="formData.telephoneNumber" type="text" class="form-control form-control-default" placeholder="Telephone number">
                                                        </div>
                                                    </div>
                                                    <div class="col-6">
                                                        <div class="input-group input-group-static null">
                                                            <label>Mobile number</label>
                                                            <input v-model="formData.mobileNumber" type="text" class="form-control form-control-default" placeholder="Mobile number">
                                                        </div>
                                                    </div>
                                                </div>        
                                                <div class="row mt-4">
                                                    <div class="col-12">
                                                        <div class="input-group input-group-static null">
                                                            <label>Address</label>
                                                            <input v-model="formData.address" type="text" class="form-control form-control-default" placeholder="Address">
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="row mt-4">
                                                    <div class="col-6">
                                                        <div class="input-group input-group-static null">
                                                            <label>City</label>
                                                            <input v-model="formData.city" type="text" class="form-control form-control-default" placeholder="City">
                                                        </div>
                                                    </div>
                                                    <div class="col-6">
                                                        <div class="input-group input-group-static null">
                                                            <label>Zipcode</label>
                                                            <input v-model="formData.zipcode" type="text" class="form-control form-control-default" placeholder="Zipcode">
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>                                                      
                                        <div class="button-row d-flex mt-6">
                                            <router-link to="/register" class="btn btn-sm bg-gradient-danger float-start">Cancel</router-link>
                                            <button @click="saveForm" class="btn btn-sm bg-gradient-success mr-2 ms-auto" type="button">Save</button>
                                        </div>                                      
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios'
import { required, email as emailValidator, helpers } from '@vuelidate/validators'
import { computed, reactive } from 'vue'
import useVuelidate from '@vuelidate/core'
import { useStore } from 'vuex'
import { useRouter } from 'vue-router'
import swal from 'sweetalert2'
import { useI18n } from 'vue-i18n';

export default {
    name: 'RegisterCreatePage',
    
    setup() {
        const { t } = useI18n()
        const store = useStore()
        const router = useRouter()
        const error = reactive({ value: '' })

        const formData = reactive({
            email: '',
            displayName: '',
            animalSpecies: '',
            address: '',
            city: '',
            zipcode: '',
            telephoneNumber: '',
            mobileNumber: '',    
        });

        const rules = computed(() => ({
            email: { 
                required: helpers.withMessage(t('common.Required'), required), 
                email: helpers.withMessage(t('common.Invalid_email_address'), emailValidator) 
            },
            displayName: { required: helpers.withMessage(t('common.Required'), required) },
            animalSpecies: { required: helpers.withMessage(t('common.Required'), required) }
        }));

        const v$ = useVuelidate(rules, formData);

        const saveForm = async () => {
            v$.value.$touch(); // Mark all fields as touched
            if (v$.value.$pending) {
                await v$.value.$validate(); // Ensure validation completes
            }
            if (!v$.value.$invalid) {
                await submitForm();
            } else {
                error.value = 'Please correct the errors in the form.';
            }
        };

        const submitForm = async () => {                
            try {
                // Show loading spinner
                store.commit('setShowLoading', true);

                // Create a FormData object
                const formDataObj = new FormData();
                
                Object.keys(formData).forEach(key => {
                    const value = formData[key];                        
                    if (value !== null && value !== undefined) {
                        formDataObj.append(key, value);
                    }
                });

                // Send data to the server
                const response = await axios.post('/register/save', formDataObj);

                if (response.data.success) {
                    swal.fire({
                        text: "Success, User created successfully!",
                        icon: "success",
                        position: "top-end",
                        timer: 1000,
                    });
                    router.push('/register');
                } else {
                    error.value = 'Oops!! Error, please contact system admin.';
                }
            } catch(e) {
                error.value = 'Oops!! Error, please contact system admin.';
            } finally {
                // Hide loading spinner
                store.commit('setShowLoading', false);
            }
        };

        return {
            formData,
            v$,
            saveForm,
            error
        };
    }
}
</script>
